<div class="zwi-headline">
  <ng-content></ng-content>
</div>
